import React from 'react';

import { ApolloProvider } from '@apollo/client/react';
import { CartOpenProvider } from "../../context/CartOpenContext";
import { CartProvider } from "../../context/CheckoutContext";
import ShopifyCachedApolloClient from "../../context/ShopifyCachedApolloClient";
import Cart from './index';

function WithCart(props){

  const client = ShopifyCachedApolloClient();

  const childrenWithProps = React.Children.map(props.children, (child, index) => {
    return React.cloneElement(child, {
      nullClient: false
    });
  });

  return (<ApolloProvider client={client}>
      <CartProvider>
        <CartOpenProvider>
          <Cart/>
          {childrenWithProps}
        </CartOpenProvider>
      </CartProvider>
    </ApolloProvider>
  );

}

export default WithCart;
